$(document).ready(function () {
  var windowWidth = $(window).width();
  if (windowWidth > 1000) {
    var win_width = 150;
  } else {
    var win_width = 0;
  }

  function scrollToTarget() {
    var $target = $(".main-wrapper");
    console.log("test");
    if ($target.length) {
      console.log($target);
      $("html, body").animate(
        {
          scrollTop: $target.offset().top - win_width,
        },
        100
      ); // Adjust scroll speed here
    }
  }

  // Scroll on page load if URL has ?
  if (window.location.search) {
    setTimeout(scrollToTarget, 100); // 1 second delay
  }

  // Scroll after 1 second when .check li is clicked
  if (windowWidth > 1000) {
    $(document).on("click", ".check li label, .remove-all", function () {
      setTimeout(scrollToTarget, 100); // 1 second delay
    });
  }
});
